import { call, take, fork } from 'redux-saga/effects'
import { cardSettingRemoveService } from '../../api/card'
import { CARD_SETTING_REMOVE } from '../../reducers/card/type'
import generalSaga from '../general'

/**
 *
 * @param {*} payload
 */
function* cardSettingsRemoveFlow(payload) {
  try {
    const { id } = payload

    yield call(cardSettingRemoveService, id)
    //yield put(operationSuccess())
  } catch (error) {
    //yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* cardSettingsRemoveWatcher() {
  while (true) {
    const action = yield take(CARD_SETTING_REMOVE)
    const { payload } = action

    yield fork(generalSaga, cardSettingsRemoveFlow, payload, false)
  }
}
